import { combineReducers } from 'redux';

import { MONITORINGS_REQUEST, MONITORINGS_RECEIVE, MONITORINGS_ERROR } from '../actions/monitorings';

export default (state = {}, action) => {

    const isFetching = (state = false, action) => {
        switch (action.type) {
            case MONITORINGS_REQUEST:
                return true;
            case MONITORINGS_RECEIVE:
            case MONITORINGS_ERROR:
                return false;
            default:
                return state;
        }
    };

    const valid = (state = false, action) => {
        switch (action.type) {
            case MONITORINGS_RECEIVE:
                return true;
            default:
                return state;
        }
    };

    const data = (state = [], action) => {
        switch (action.type) {
            case MONITORINGS_RECEIVE:
                return action.payload;
            default:
                return state;
        }
    };

    return combineReducers({
        isFetching,
        valid,
        data
    })(state, action);
}